<template>
    <div class="text-center highlight-footer">
        <p class="text--red text--extrabold mb-0 register-callout" v-in-viewport>
            <nuxt-link to="/register/" class="text--red text--black" style="font-size: 22px;cursor:pointer">Register Today</nuxt-link> to learn the benefits of <br>Community Built From The Ground Up at New Seaton.
        </p>
        <br>
        <b-img src="/img/highligh-footer-nowopen-nov1.png" fluid center class="mb-0 d-none d-md-block" alt="New Seaton | Community Built From The Ground Up"/>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>